import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";

import { setSelectedSearchTerm } from "../../../../../../../../features/aiRecomendationTabSlice";
import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSearchParams } from "react-router-dom";

export default function StLevelFilterCard() {
  const { selectedSearchTerm, allSTLevels } = useSelector(
    (state: any) => state.aiRecomandationTab
  );

  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    const searchParam = searchParams.get("search");
    dispatch(setSelectedSearchTerm(searchParam));
    setInputValue(searchParam || "");
    // eslint-disable-next-line
  }, []);

  const handleSearch = (searchValue: string | null) => {
    const trimmedValue = searchValue?.trim() || "";
    dispatch(setSelectedSearchTerm(trimmedValue));
    setSearchParams((prevParams) => {
      const updatedParams = Object.fromEntries(prevParams);
      if (trimmedValue) {
        updatedParams.search = trimmedValue;
        updatedParams.page = "0";
      } else {
        delete updatedParams.search;
      }
      return updatedParams;
    });
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch(inputValue);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Autocomplete
        fullWidth
        disablePortal
        sx={{ width: "390px" }}
        options={allSTLevels.map((opt: any) => opt.search_term)}
        value={selectedSearchTerm || null}
        inputValue={inputValue}
        onInputChange={(_, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(_, newValue: string | null) => {
          handleSearch(newValue);
          setInputValue(newValue || "");
        }}
        getOptionLabel={(opt) => opt || ""}
        // Hide clear button when input is empty
        clearIcon={inputValue ? undefined : null}
        freeSolo // Allow text input that's not in the options list
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search Term"
            onKeyDown={handleKeyDown}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ marginLeft: "12px" }} />
                </InputAdornment>
              ),
            }}
            data-tracker="613"
            color="secondary"
          />
        )}
        size="small"
      />
    </Box>
  );
}
